import { isEqual as deepEqual } from '@react-hookz/deep-equal';

function isNull<T>(value?: T | null): value is null {
  return value === null;
}

function isUndefined<T>(value?: T | null): value is undefined {
  return typeof value === 'undefined';
}

function isString<T>(value?: T | string): value is string {
  return typeof value === 'string';
}

function isBoolean<T>(value?: T | boolean): value is boolean {
  return value === true || value === false;
}

function isBooleanString<T>(value?: T | string): value is 'true' | 'false' {
  return value === 'true' || value === 'false';
}

function isDeepEqual(valueA?: unknown, valueB?: unknown) {
  return deepEqual(valueA, valueB);
}

function isNullOrUndefined<T>(value?: T | null) {
  return isNull(value) || isUndefined(value);
}

function isObject(obj?: unknown): obj is object {
  return typeof obj === 'object';
}

function isObjectEmpty(obj?: object): boolean {
  if (isUndefined(obj)) {
    return true;
  }

  return Object.keys(obj).length === 0;
}

export {
  isBoolean,
  isBooleanString,
  isDeepEqual,
  isNull,
  isNullOrUndefined,
  isObject,
  isObjectEmpty,
  isString,
  isUndefined,
};
